<template>
    <el-row :gutter="30"  class="mw-100 manage-footer-social" >
        
        <el-col :lg="24" :xs="24">
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addFooterSocialRef"
                    :model="currentFooterSocialData"
                    :rules="currentFooterSocialDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageFooterSocial('addFooterSocialRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="footer Social image" prop="iconBase64">
                                <el-image 
                                    style="width: 150px; height: 150px;margin-right:20px" 
                                    :src="isAddFooterSocial ? currentFooterSocialData.iconURL :  $getImage(currentFooterSocialData.iconURL) || ''" 
                                    fit="cover"
                                    :zoom-rate="1.2"
                                    :preview-src-list="[isAddFooterSocial ? currentFooterSocialData.iconURL : $getImage(currentFooterSocialData.iconURL)]"
                                    :preview-teleported="true"
                                    class="bg-theme"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <font-awesome-icon :icon="['fas', 'image']" />
                                        </div>
                                    </template>
                                </el-image>
                                <el-upload
                                    ref="iconBase64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadImage"
                                    :disabled="fileUploaded"
                                    :on-remove="handleRemoveImage"
                                    accept="image/png, image/jpeg,image/gif"
                                    class="font-24 d-flex align-center flex-1"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="24" :xs="24">
                            <el-form-item  label="site URL" :prop="`siteURL`" >
                                <el-input type="text" v-model="currentFooterSocialData.siteURL"></el-input>    
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
           
            isAddFooterSocial:true,
            currentFooterSocial:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentFooterSocialData:{},
            currentFooterSocialDataRules:{
                siteURL:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                
            }
        };
    },
    computed:{
        cachedFooterSocial(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerSocials.currentFooterSocial || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedFooterSocial.id) {
            this.isAddFooterSocial = false;
            this.currentFooterSocialData = JSON.parse(JSON.stringify(this.cachedFooterSocial));
            
        }else{
            this.$router.push({
                name:'manage-footer-social',
            })
            this.isAddFooterSocial = true;
            this.currentFooterSocialData = this.initState()
            this.currentFooterSocialDataRules.iconBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
        }
    },
    
    methods:{
        initState(){
            return {
                translates:this.$setTranslateKeys({
                    'siteURL':'',
                })
            }
        },
       
        async manageFooterSocial(formName){
            const element = this.$refs[formName];
            element.validate(async (valid) => {
                if (!valid) {
                    this.$message({
                        message:`please fill the data in the form `,
                        type:'info',
                        duration:5000,
                        showClose: true,
                    });
                }
            }).then(data =>{
                if (data){
                    this.manageFooterSocialAfterValidate()
                }
            })  
           
            
            
            
            
            
        },
        async manageFooterSocialAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddFooterSocial ? 'addFooterSocial':'updateFooterSocial',this.currentFooterSocialData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getFooterSocial');
                this.$router.push({
                    name:'footer-socials-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['iconBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentFooterSocialData.iconBase64 = evt.target.result;
                }); 
                this.currentFooterSocialData.iconURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentFooterSocialData.iconURL = this.isAddFooterSocial ? '' : this.cachedFooterSocial.iconURL
        }, 
       
    }
}
</script>
<style lang="scss">
    .manage-footer-social {
        .ck-editor {
            width:100%;
        }
    }
</style>